import GameDie from '../../assets/audio/gm_die.mp3';
import GameBackground from '../../assets/audio/gm_background.mp3';
import GameJump from '../../assets/audio/gm_jump.wav';
import GameOrb from '../../assets/audio/gm_orb.wav';
import GamePortal from '../../assets/audio/gm_portal.wav';

function Audio() {
    return <>
        <audio id="sound_die">
            <source src={GameDie} type="audio/mpeg" ></source>
        </audio>
        <audio id="sound_bg" loop>
            <source src={GameBackground} ></source>
        </audio>
        <audio id="sound_jump">
            <source src={GameJump} ></source>
        </audio>
        <audio id="sound_orb">
            <source src={GameOrb} ></source>
        </audio>
        <audio id="sound_portal">
            <source src={GamePortal} ></source>
        </audio>
    </>;
}

export default Audio;
